/**
 * Indica si una regla de descuento por producto aplica a la fila de inventario del producto
 * (mismo código y, si la regla es por una sola localidad, misma localidad).
 * Sin alcanceLocalidad se asume "todas" (reglas antiguas).
 */
export function reglaDescuentoAplicaAProducto(regla, producto) {
  if (!regla || !producto || regla.tipoAplicacion !== 'producto') return false;
  // Comparar como string: el codigo puede venir numerico desde MySQL/JSON.
  if (String(regla.codigoProducto ?? '').trim() !== String(producto.codigo ?? '').trim()) {
    return false;
  }
  const alcance = regla.alcanceLocalidad || 'todas';
  if (alcance !== 'una') return true;
  const lr = String(regla.localidad ?? '').trim();
  const lp = String(producto.localidad ?? '').trim();
  return lr === lp;
}
